import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, DataService, FireForesightService, GeoCastingService, SiteTypeService } from 'src/api/services';
import { User, Customer, CustomerSummary, StatusType, Status, Incident, Widget, Note, SiteTwin, ResponsibleParty, FalsePositiveType, Zone, Detection } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { ActivatedRoute } from '@angular/router';
import { IMultiSourceMultiValueWidget, TimeSeriesDetail } from 'src/app/models/dashboard';
import { AbstractDataService } from 'src/service/data.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';
import { Location, MapComponent, ElevationProfile, ElevationProfilePoint } from 'src/app/components/map/map.component';
import { SmartImageComponent } from 'src/app/components/smart-image/smart-image.component';
import { SmartImageDetail, SmartImageListComponent } from 'src/app/components/smart-image-list/smart-image-list.component';
import { IconService } from 'src/service/icon.service';
import { CameraControllerComponent } from 'src/app/components/camera-controller/camera-controller.component';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import * as L from 'leaflet';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-incident',
  templateUrl: './fire-foresight-incident.component.html',
  styleUrls: ['./fire-foresight-incident.component.css']
})
export class FireForesightIncidentComponent implements OnInit, OnDestroy {
  @ViewChild('responsibleModal', { static: false }) responsibleModal: ModalDirective;
  @ViewChild('falsePositiveModal', { static: false }) falsePositiveModal: ModalDirective;
  @ViewChild('cameramap', { read: MapComponent, static: true }) map: MapComponent;
  @ViewChild('chat') private chat: ElementRef
  @ViewChild('livestream') private livestream: ElementRef<HTMLImageElement>;

  @ViewChild('incidentImage', { read: SmartImageListComponent, static: true }) incidentImage: SmartImageListComponent;
  public showLineAt: any;
  

  public zoom: Boolean;
  public list: StatusType[];
  public responsibleParties: ResponsibleParty[];
  public falsePositiveTypes: FalsePositiveType[];
  @Input() public incidentId: number;
  @Input() public fullScreen: boolean = true;
  //public incident: Incident;
  public liveWidget: IMultiSourceMultiValueWidget;
  public latestImageUrl: string;
  public liveExpand: boolean = false;
  public mapExpand: boolean = false;
  public dayMode: boolean = false;
  public weatherMobileExpanded: boolean = false;
  public weatherDesktopExpanded: boolean = false;
  public selectedNote: Note;
  public newNote: string;
  public liveStreaming: boolean = false;
  public mapHeight: number = 370;
  public oldLocation: Location;
  public ptzBearing: number;
  public ptzElevation: number;
  public ptzZoom: number;

  public cameraLatitude: number | undefined;
  public cameraLongitude: number | undefined;

  public timelines: any[];
  public elevationProfile: ElevationProfile;

  // Fire spread animation properties
  public fireSpreadModel: any;
  public currentFrameIndex: number = 0;
  public isAnimating: boolean = false;
  public animationInterval: any;
  public fireSpreadLayer: any;
  
  // Area of interest layer
  public areaOfInterestLayer: any;

  constructor(
    public app: ApplicationConfigService,
    //public cmd: CommandService,
    public security: AzureAuthService,
    private svc: FireForesightService,
    public fire: FireService,
    private siteTypeService: SiteTypeService,
    private dataService: DataService,
    private toasterService: ToastrService,
    private data: DataService,
    private route: ActivatedRoute,
    private iconSvc: IconService,
    private geoCastingSvc: GeoCastingService) {
    // console.log("fire-foresight-admin constructor")
  }

  private getTimestampMs(value: any): number {
    if (!value) {
      return 0;
    }

    if (typeof value === 'number') {
      return value;
    }

    let dateValue = value;
    if (typeof dateValue === 'string') {
      const hasTimezoneSuffix = /(Z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
      if (!hasTimezoneSuffix) {
        dateValue += 'Z';
      }
    }

    const parsed = Date.parse(dateValue);
    return Number.isNaN(parsed) ? 0 : parsed;
  }


  private scrollToBottom(): void {
    //console.log(this.chat.nativeElement.scrollHeight);
    if (this.chat && this.chat.nativeElement) {
      this.chat.nativeElement.scrollTop = this.chat.nativeElement.scrollHeight;
    }
  }

  ngOnInit(): void {
    console.log("Showing Incident Page", this.incidentId);
    this.iconSvc.getPins(null);
    
    // Setup global merge function for popup buttons
    (window as any).mergeIncident = (primaryId: number, secondaryId: number) => {
      this.mergeIncidents(primaryId, secondaryId);
    };
    
    this.svc.FireForesightGetStatusTypes().subscribe(r => {
      console.log("ngOnInit", r);
      this.list = r;
    });
    this.svc.FireForesightGetResponsibleParties(this.app.customerId).subscribe(r => {
      this.responsibleParties = r;
    });
    this.svc.FireForesightGetFalsePositiveTypes().subscribe(r => {
      this.falsePositiveTypes = r;
    })

    if (this.incidentId) {
      if (this.map) {
        this.map.removeIncidentLocations();
        this.map.removeActiveIncidentLocation();
        this.map.hideDetections();
      }
      this.fire.getIncident(this.incidentId, i => {
        this.loadIncident();
        setTimeout(() => this.scrollToBottom(), 1000);
      });
    }

    this.route.params.subscribe(params => {
      this.incidentId = params["incidentId"];
      if (this.map) {
        this.map.removeIncidentLocations();
        this.map.removeActiveIncidentLocation();
        this.map.hideDetections();
      }
      this.fire.getIncident(this.incidentId, i => {
        this.loadIncident();
        setTimeout(() => this.scrollToBottom(), 1000);
      });
    });

    //this.fire.startConnection().then(() => { 
    this.fire.connection.on('ReceiveMessage', (user, message) => {
      console.log("ReceiveMessage", message);
    });
    this.fire.connection.on('IncidentUpdated', (incident: Incident, user: string) => {
      console.log("IncidentUpdated", incident);
      if (incident.incidentId.toString() == this.incidentId.toString() && user != this.security.account.name) {
        this.toasterService.info("Incident Updated", user);
        this.fire.incident.notes = incident.notes;
        this.fire.incident.status = incident.status;
        if (this.fire.incident.initialLocationLat == null) {
          this.fire.incident.initialLocationLat = incident.initialLocationLat;
          this.fire.incident.initialLocationLon = incident.initialLocationLon;
          this.fire.incident.responsiblePartyId = incident.responsiblePartyId;
          this.fire.incident.incidentReference = incident.incidentReference;
          this.fire.incident.incidentReferenceUrl = incident.incidentReferenceUrl;
          this.fire.incident.incidentStartDate = incident.incidentStartDate;
          this.fire.incident.incidentEndDate = incident.incidentEndDate;
          this.fire.incident.initialNorthing = incident.initialNorthing;
          this.fire.incident.initialEasting = incident.initialEasting;
          this.fire.incident.initialUTMZone = incident.initialUTMZone;
          this.fire.incident.initialDistance = incident.initialDistance;
          this.location = {} as Location;
          this.location.latitude = incident.initialLocationLat;
          this.location.longitude = incident.initialLocationLon;
          this.map.showActiveIncidentLocation(this.location, this.iconSvc.pins['Fire Detection']);
        }
      }
    });
    this.fire.connection.on('IncidentOpen', (incidentId: number, user: string) => {
      if (incidentId.toString() == this.incidentId.toString() && user != this.security.account.name) {
        this.toasterService.info("Now Watching", user);
      }
    });
    //});
  }

  ngOnDestroy(): void {

    if (this.map) {
      this.map.removeIncidentLocations();
      this.map.removeActiveIncidentLocation();
    }
    this.fire.stopConnection();
    this.stopStream();
    if (this.streamTimeout) {
      clearTimeout(this.streamTimeout);
    }
    
    // Clean up fire spread animation
    this.stopFireSpreadAnimation();
    
    // Clean up area of interest layer
    this.removeAreaOfInterest();
    
    // Clean up global merge function
    delete (window as any).mergeIncident;
  }

  private stopStream(): void {
    // Explicitly clear the image src to stop the browser from loading the stream
    if (this.livestream && this.livestream.nativeElement) {
      this.livestream.nativeElement.src = '';
    }
    this.streamUrl = null;
    this.liveStreaming = false;
  }


  fireLocationUpdated(event){ 
    console.log("fireLocationUpdated", event);
    const detection =  this.fire.incident.detections[this.selectedImageIndex]
    detection.detectionMetaData = event;

    // what we want: "{"objects":[{"object":"Fire","confidence":"1","rectangle":{"x":841,"y":383,"w":674,"h":244}}]}"
    // what we have: "{"x":1004,"y":206,"width":368,"height":122,"imageWidth":1920,"imageHeight":1080}"
    
    this.svc.FireForesightUpdateDetectionMetaData({
      detectionId: detection.detectionId,
      detectionMetaData: JSON.stringify({"objects":[{object:"Fire", confidence:"1", rectangle:{x:event.x, y:event.y, w:event.width, h:event.height}}]})
    } as Detection).subscribe(r => { 

    });
    this.mode = 7;
  }

  selectedImageIndex: number = 0;
  imageIndexChanged(index: number){
    this.selectedImageIndex = index;
  }

  getSegments() {
    if (this.fire.twin && this.fire.twin.parameters) {
      return Object.values(this.fire.twin.parameters).filter(f => f.bearing != null && !f.hidden).length;
    }
    return 0;
  }

  streamUrl: string;
  streamTimeout;
  timeout: number = 0;
  liveStream() {
    if (!this.liveStreaming) {
      // only redirect the camera when you request live streaming
      this.fire.RunCommand({
        customerId: this.app.customerId,
        command: {
          siteUri: this.fire.camera.siteUri,
          action: 'point',
          parameters: [
            { parameterName: 'zoom', parameterValue: this.ptzZoom.toString() },
            { parameterName: 'direction', parameterValue: this.ptzBearing.toString() },
            { parameterName: 'elevation', parameterValue: this.ptzElevation.toString() }
          ]
        }
      }).then(c => {
        this.toasterService.success(`Camera redirected to fire: ${Math.round(this.ptzBearing)} ${Math.round(this.ptzElevation)} ${this.ptzZoom}`);
      }, err => {
        this.toasterService.error("Failed to redirect camera to fire");
      });
    }

    if (this.streamTimeout != null) {
      clearTimeout(this.streamTimeout);
      this.timeout = 0;
    }

    if (this.liveStreaming) {
      this.stopStream();
      //this.streamUrl = this.fire.camera?.manualCameraLatestUrl;
    } else {
      var cameraId = this.fire.camera?.siteId;
      if (cameraId == null) {
        return;
      }
      //this.streamUrl = "/assets/images/connecting.png";
      this.svc.FireForesightGetStreamKey({ customerId: this.app.customerId, siteId: cameraId }).subscribe(streamKey => {
        const finalStreamUrl = `/api/FireForesight/GetSecureStream/${streamKey}`;
        this.streamUrl = finalStreamUrl;

        this.streamTimeout = setInterval(() => {
          if (this.timeout >= 100) {
            this.liveStream();
            this.toasterService.success("Video Feed Timed Out");
            clearTimeout(this.streamTimeout);
            this.timeout = 0;
            setTimeout(() => {
              this.liveStreaming = false
              this.stopStream();
              this.mode = 70;
            }, 1000);
          } else {
            this.timeout = this.timeout + 0.25;
          }
        }, 200);
      }, err => {
        this.toasterService.error("Failed to start camera stream");
        this.liveStreaming = false;
        console.error("FireForesightGetStreamKey error:", err);
        this.streamUrl = null;
      });
    }

    this.liveStreaming = !this.liveStreaming;

    // todo: issue command to redirect camera in the direction of the incident

    //this.streamUrl = '/api/FireForesight/GetStream/' + this.app.customerId + '/' + this.fire.camera?.siteId;
    //this.liveStreaming = !this.liveStreaming;
  }

  getModeName(): string {
    switch (this.mode) {
      case 0: return "Normal";
      case 1: return "Latest Image";
      case 2: return "Live";
      case 3: return "Zoomed";
      case 4: return "Day Time";
      case 5: return "Edit Fire Location";
      case 7: return "Detection";
      case 10: return "Latest Image";
      case 30: return "Zoomed";
      case 40: return "Day Time";
      case 70: return "Detection";
      default: return "Unknown";
    }
  }

  mode: number = 7;
  lastMode: number = 0;
  state: 0 | 1 | 2 | null = null;
  changeMode(mode: number, state: 0 | 1 | 2  | null = null) {
    this.state = state;
    if (state != null) {
      // if state = false, then force back to previous
      // exit hover
      if (state == 0) {
        // only return if the current mode is not the one being hovered over
        if (this.mode != mode / 10) {
          this.mode = this.lastMode;
          return;
        }
      }
      // if state = true, then force to the new mode and record the last
      // enter hover
      if (state == 1) {
        this.lastMode = this.mode;
        this.mode = mode;
        return;
      }
    }
    if (this.mode == mode) {
      // this is a toggle back to the previous mode
      this.mode = this.lastMode;
      this.stopStream();
      return;
    }
    this.lastMode = this.mode;
    this.mode = mode;
    if (mode == 7) {
      // normal mode
    }
    else if (mode == 1) {
      // timelapse mode - but only if click
      this.loadTimelapse();
    }
    else if (mode == 2) {
      // live mode
      this.liveStream();
    }
    else if (mode == 3 || mode == 30) {
      // zoomed mode
      this.toogleZoomedImages();
    }
  }

  layersSelected: boolean = false;
  public toggleLayers() {
    if (this.layersSelected == false) {
      console.log("Toggle Layers");
      // step through all layers and add
      if (this.fire.layers == null) {
        this.svc.FireForesightGetMapLayers(this.app.customerId).subscribe(layers => {
          this.fire.layers = layers;
          if (this.fire.layers) {
            this.toggleLayers();
          }
        });
      }
      else {
        this.layersSelected = true;
        for (let layer of this.fire.layers) {
          if ((layer as any).layer == null) {
            if (layer.layerTypeId == 1) {
              // geojson
              this.data.DataProxy(layer.url).subscribe(resp => {
                var j = JSON.parse(resp);
                (layer as any).layer = this.map.loadLinkLayerContent('geojson', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
              });
            }
            else if (layer.layerTypeId == 2) {
              // kml/kmz
              if (layer.url.slice(-3).toLowerCase() == "kmz") {
                // KMZ files need to be fetched as binary, so pass URL directly
                var l = this.map.loadLinkLayerContent('kmz', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {

                });
                (layer as any).layer = l;
              } else {
                // KML files can be fetched as text
                this.data.DataProxy(layer.url).subscribe(resp => {
                  const parser = new DOMParser();
                  const kml = parser.parseFromString(resp, 'text/xml');
                  // Resolve relative href URLs against the original KML source
                  const hrefEls = kml.getElementsByTagName('href');
                  for (let i = 0; i < hrefEls.length; i++) {
                    const val = (hrefEls[i].textContent || '').trim();
                    if (val && !val.startsWith('http') && !val.startsWith('data:') && !val.startsWith('#')) {
                      try { hrefEls[i].textContent = new URL(val, layer.url).href; } catch {}
                    }
                  }
                  var l = this.map.loadLinkLayerContent('kml', layer.mapLayerId, kml, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {

                  });
                  (layer as any).layer = l;
                }, err => {
                  //this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
                });
              }
            }
            else if (layer.layerTypeId == 3) {
              // esri
              (layer as any).layer = this.map.loadLinkLayerContent('esri', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
            }
            else if (layer.layerTypeId == 4) {
              // cap
              this.data.DataProxy(layer.url).subscribe(resp => {
                var j = JSON.parse(resp);
                var l = this.map.loadLinkLayerContent('cap', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {

                });
                (layer as any).layer = l;
              }, err => {
                //this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
              });
            }
            else if (layer.layerTypeId == 5) {
              // wms
              var l = this.map.loadLinkLayerContent('wms', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {

              });
              (layer as any).layer = l;
            }
            else if (layer.layerTypeId == 7) {
              var l = this.map.loadLinkLayerContent('tilemap', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, null);
              (layer as any).layer = l;
            }
            else if (layer.layerTypeId == 8) {
              //wa emergency maps

              //this is not implemented fully yet
              //but is here for future to decode the additional data
              //that's packed in a dat file
              if (layer.url.slice(-3).toLowerCase() != "dat") {
                this.data.DataProxy(layer.url).subscribe(resp => {
                  var j = JSON.parse(resp);
                  (layer as any).layer = this.map.loadLinkLayerContent('waemergency', layer.mapLayerId, j, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
                  });
                });
              }
              else {

                //TODO: This can't be loaded through the proxy
                //but also it's just not finished but probably not needed
                (layer as any).layer = this.map.loadLinkLayerContent('waemergency-dat', layer.mapLayerId, layer.url, layer.fileLayerName, layer.styles, layer.tileSize, layer.useProxy, feature => {
                });

              }
            }
          }

          /*if ((layer as any).layer != null){
            this.map.showLayer((layer as any).layer);
          }*/
        }
      }

    } else {
      if (this.fire.layers) {
        //this.map.removeLayer(this.tasAlerts);
        this.layersSelected = false;
        //todo: step through all layers and remove
        for (let layer of this.fire.layers) {
          if ((layer as any).layer) {
            this.map.removeLayer((layer as any).layer);
            (layer as any).layer = null;
          }
        }

      }

    }
  }


  location: Location;

  // Calculate distance between two lat/lon points using Haversine formula
  // Returns distance in kilometers
  private calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Earth's radius in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private getElevationProfile(bearing: number): void {
    // Use the geocasting service to get the elevation profile for the camera location and bearing
    if (!this.fire.camera || !this.fire.camera.siteId) {
      console.warn('Camera or siteId not available for elevation profile');
      return;
    }

    this.geoCastingSvc.GeoCastingGetElevationProfileForCamera({
      customerId: this.app.customerId,
      siteId: this.fire.camera.siteId,
      bearing: bearing
    }).subscribe(async (blob: Blob) => {
      try {
        // Parse the blob response as JSON
        const text = await blob.text();
        const data = JSON.parse(text);
        
        // Set the elevation profile from the API response
        this.elevationProfile = data as ElevationProfile;
        
        // Update the map's observer height from camera height
        if (this.map && this.fire.incident?.site?.cameraHeight) {
          this.map.observerHeight = this.fire.incident.site.cameraHeight;
        }
      } catch (error) {
        console.error('Failed to parse elevation profile data:', error);
        this.toasterService.error('Failed to parse elevation profile data');
      }
    }, error => {
      console.error('Failed to load elevation profile:', error);
      this.toasterService.error('Failed to load elevation profile');
      // Fallback to mock data if API fails
      if (this.fire.camera.latitude != null && this.fire.camera.longitude != null) {
        // this.elevationProfile = this.generateMockElevationProfile(
        //   this.fire.camera.latitude, 
        //   this.fire.camera.longitude, 
        //   bearing
        // );
      }
      
    });
  }

  

  // Generate mock elevation profile data for visualization
  // This will be replaced with actual API call when backend is ready
  private generateMockElevationProfile(startLat: number, startLng: number, bearing: number): ElevationProfile {
    const data: ElevationProfilePoint[] = [];
    const numPoints = 3001; // 3000 segments = 3001 points
    const stepDistanceKm = 0.01; // 10 meters per point
    const earthRadiusKm = 6371;
    
    const bearingRad = bearing * (Math.PI / 180);
    
    let currentLatRad = startLat * (Math.PI / 180);
    let currentLngRad = startLng * (Math.PI / 180);
    
    let cumulativeDistance = 0;
    let maxElevation = 0;

    for (let i = 0; i < numPoints; i++) {
      // Geographic point projection (Direct Spherical Kinematics)
      if (i > 0) {
        const angDist = stepDistanceKm / earthRadiusKm;
        const nextLatRad = Math.asin(
          Math.sin(currentLatRad) * Math.cos(angDist) +
          Math.cos(currentLatRad) * Math.sin(angDist) * Math.cos(bearingRad)
        );
        const nextLngRad = currentLngRad + Math.atan2(
          Math.sin(bearingRad) * Math.sin(angDist) * Math.cos(currentLatRad),
          Math.cos(angDist) - Math.sin(currentLatRad) * Math.sin(nextLatRad)
        );
        
        currentLatRad = nextLatRad;
        currentLngRad = nextLngRad;
        cumulativeDistance += stepDistanceKm;
      }

      const lat = currentLatRad * (180 / Math.PI);
      const lng = currentLngRad * (180 / Math.PI);

      // Generate a scenic 30km elevation profile (up to 1200m and rolling)
      const ratio = i / (numPoints - 1);
      let elev = 50 + Math.sin(ratio * Math.PI) * 1150; // main climb
      elev += Math.sin(ratio * Math.PI * 15) * 80;      // hills
      elev += Math.sin(ratio * Math.PI * 50) * 15;      // micro terrain
      if (elev < 0) elev = 0;
      
      maxElevation = Math.max(maxElevation, elev);

      data.push({
        index: i,
        lat: parseFloat(lat.toFixed(6)),
        lng: parseFloat(lng.toFixed(6)),
        elevation: Math.round(elev),
        distance: parseFloat(cumulativeDistance.toFixed(2))
      });
    }
    
    return {
      points: data,
      bearing: bearing,
      maxDistance: cumulativeDistance,
      maxElevation: maxElevation
    };
  }
  
  locationSelectActive: boolean = false
  public toggleLocationSelect(update = true) {
    if (this.locationSelectActive == false) {
      this.locationSelectActive = true;
      if (this.location == null) {
        this.location = {} as Location;
      }
      this.oldLocation = this.deepClone(this.location);
      this.map.enableLocationSelect(this.iconSvc.pins['Fire Detection']);
    } else {
      // save the location
      this.locationSelectActive = false;
      if (update == true) {
        this.svc.FireForesightSetInitialFireLocation({ incidentId: this.fire.incident.incidentId, latitude: this.location.latitude, longitude: this.location.longitude })
          .subscribe(r => {
            this.fire.incident = r;
            this.toasterService.success("Location Updated");
          }, err => {
            this.toasterService.error("Location Update Failed");
          });
        this.map.disableLocationSelect();
      }
      else {
        this.map.disableLocationSelect(this.oldLocation);
        this.toasterService.info("Location Update Cancelled");
      }
      //this.map.disabeLocationSelect();
    }
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  formatResponseTime(value: number): string {
    if (value == null) {
      return '--';
    }

    const totalSeconds = Math.max(0, Math.floor(value));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }

    return `${seconds} s`;
  }

  getResponseTimeClass(value: number): string {
    if (value == null) {
      return '';
    }

    if (value > 300) {
      return 'text-danger';
    }

    if (value > 120) {
      return 'text-warning';
    }

    return '';
  }

  zoomed: boolean = false;
  detectionImages: SmartImageDetail[];
  latestImages: SmartImageDetail[];
  latestZoomedImages: SmartImageDetail[];
  timeLapseLoading: boolean = false;
  loadTimelapse() {
    console.log('Loading Image History...')
    this.timeLapseLoading = true;
    const imageUri = this.fire.incident.imageFeedUri;
    if (imageUri) {
      // now load the larger data set of images
      // time = 'yyyy-MM-dd HH:mm:ss,2024-11-13 11:00:00'
      const start = this.formatDate(this.fire.incident.incidentStartDate);
      const end = this.fire.incident.incidentEndDate == null ? '1h' : this.formatDate(this.fire.incident.incidentEndDate);
      /*if (end == null || end == ''){
        end = '1h';
      }*/
      const period = `${start},${end}`;
      console.log('Load period', period);
      this.dataService.DataGetData({  customerId: this.app.customerId,
        request:{
          period: period, 
          type: 'media',
          timeZoneOffset: this.app.getTimeZoneOffset(null),
          forceEmbed: false,
          index: 0,
          publishedIdentifier: null,
          siteUri: null,
          timeSeries: {
            single: {
              variable: {
                uri: imageUri,
                transforms: null,
              }
            }
          }
        }
      }).subscribe(r => {
        //TimeSeries:{ Variable:{Uri:  imageUri}}, transforms: null, Period: '-4h:1h', Type:"media", TimeZoneOffset: 0}).subscribe(r => {
        //this.latestImageUrl = r.values[0].valueStr;
        this.latestImages = r.values.map(i => { return { src: i.valueStr, overlay: null, timeStamp: i.timeStamp } as SmartImageDetail });
        //this.latestZoomedImages
        this.timeLapseLoading = false;
      }, err => {
        console.error(err);
      });
    }
  }

  canClickStatus(status: StatusType) {
    if (this.fire.incident == null || this.fire.incident.status == null) {  
      return false;
    } 
    var statusId = this.fire.incident.status.statusId
    if (statusId == 1 || statusId == 10) { // its a new detection
      if (status.statusId == 2 || status.statusId == 5 || status.statusId == 7) {
        // allow "Investigating" or "Not a Fire" or "Watching"
        return true;
      }
    }
    if (statusId == 2) { // investigating
      if (status.statusId == 3) {
        // allow "Confirmed"
        if (this.fire.incident.initialLocationLat == null && this.fire.incident.initialLocationLon == null) {
          return false;
        }
        return true;
      }
      if (status.statusId == 5 || status.statusId == 7 || status.statusId == 14 || status.statusId == 15) {
        // allow "Not a Fire" or "Watching" or "Planned Burn" or "Temporary Ignore"
        return true;
      }
    }
    if (statusId == 3) { // confirmed
      if (/*status.statusId == 4 || */status.statusId == 5 || status.statusId == 6 || status.statusId == 8 || status.statusId == 14 || status.statusId == 15) {
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire" or "Planned Burn" or "Temporary Ignore"
        return true;
      }
    }
    if (statusId == 8) { // escalated
      if (/*status.statusId == 4 || */status.statusId == 5 || status.statusId == 6 || status.statusId == 7 || status.statusId == 9) {
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire"
        return true;
      }
    }
    if (statusId == 9) { // acknowledged
      if (/*status.statusId == 4 ||*/ status.statusId == 6) {
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire"
        return true;
      }
    }
    if (statusId == 11) { // duplicate
      if (status.statusId == 4 || status.statusId == 404) {
        // allow "Confirmed and Ignore" or "Ignore"
        return true;
      }
    }

    if (statusId == 14) { // planned burn
      if (status.statusId == 4 || status.statusId == 5) {
        // allow "Confirmed and Ignore" or "Not a Fire""
        return true;
      }
    }

    if (statusId == 15) { // temporary ignore
      if (status.statusId == 4 || status.statusId == 5) {
        // allow "Confirmed and Ignore" or "Not a Fire""
        return true;
      }
    }

    if (statusId == 7) { // watching
      if (status.statusId == 8) {
        // allow "Escalated"
        if (this.fire.incident.initialLocationLat == null && this.fire.incident.initialLocationLon == null && this.fire.incident.responsiblePartyId == null) {
          return false;
        }
        return true;
      }
      if (/*status.statusId == 4 || */status.statusId == 5 || status.statusId == 6) {
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire"
        return true;
      }
    }



    // anything else - can return to investigating
    if (status.statusId == 2) {
      // allow "Investigating"
      return true;
    }
    return false;
  }

  async loadIncident() {
    //this.mode = 7;
    // if incident status is "Unconfirmed" or "Investigating" then mode should be 7 (Detection),
    // otherwise, mode should be 1 (Latest)
    if (this.fire.incident.status.statusId == 1 || this.fire.incident.status.statusId == 2) {
      this.mode = 7;
    } else {
      this.mode = 1;
    }
    this.newNote = '';

    // cleanup the previous page first
    this.liveStreaming = false;
    this.stopStream();
    this.latestImages = null;
    this.timeLapseLoading = false;
    //this.mode = 0;
    if (this.streamTimeout) {
      clearTimeout(this.streamTimeout);
    }
    //stops us showing the previous camera location by accident
    this.cameraLatitude = undefined;
    this.cameraLongitude = undefined;
    
    // Clean up area of interest layer from previous incident
    this.removeAreaOfInterest();


    if (this.fire.incident) {
      this.ptzBearing = this.fire.incident.bearing;
      this.ptzElevation = this.fire.incident.elevation;
      this.ptzZoom = 4;
      if (this.streamTimeout) {
        clearTimeout(this.streamTimeout);
      }
      this.liveStreaming = false;
      this.stopStream();
      this.latestImages = null;
      this.timeLapseLoading = false;
      
      // Track all camera twins for bounds calculation
      const cameraTwins: SiteTwin[] = [];
      
      this.fire.getCamera(this.fire.incident.site.siteId, false, c => {
        const excludedSiteIds = new Set<number>([c?.siteId]);
        if (this.fire.incident.duplicateIncidents) {
          for (const duplicateIncident of this.fire.incident.duplicateIncidents) {
            if (duplicateIncident?.site?.siteId != null) {
              excludedSiteIds.add(duplicateIncident.site.siteId);
            }
          }
        }

        this.displayAdditionalLoadedFireCameras(excludedSiteIds);

        const normalizedCameraLatitude = c?.latitude ?? this.fire.camera?.twin?.latitude;
        const normalizedCameraLongitude = c?.longitude ?? this.fire.camera?.twin?.longitude;
        if (normalizedCameraLatitude != null) {
          c.latitude = normalizedCameraLatitude;
          if (this.fire.camera?.twin) {
            this.fire.camera.twin.latitude = normalizedCameraLatitude;
          }
        }
        if (normalizedCameraLongitude != null) {
          c.longitude = normalizedCameraLongitude;
          if (this.fire.camera?.twin) {
            this.fire.camera.twin.longitude = normalizedCameraLongitude;
          }
        }

        var fov = this.fire.incident.cameraFieldOfView;//  360 / Math.max(Object.values(this.fire.twin.parameters).filter(f => f.bearing != null && !f.hidden).length,2);
        var group = this.map.displaySites([this.fire.camera.twin], this.getIcon, null, null, true);
        // Convert distance from km to meters for the arc radius, increased by 10%
        let distanceKm: number | undefined;
        if (this.fire.incident.initialDistance) {
          distanceKm = this.fire.incident.initialDistance;
        } else if (this.location?.latitude != null && this.location?.longitude != null && c.latitude != null && c.longitude != null) {
          // Calculate distance if not provided
          distanceKm = this.calculateDistance(c.latitude, c.longitude, this.location.latitude, this.location.longitude);
        }
        const distanceMeters = distanceKm ? distanceKm * 1100 : undefined;
        this.map.displayBearing(this.fire.camera.twin, this.fire.incident.cameraBearing, fov, distanceMeters);
        
        // Get elevation profile for the bearing from API
        this.getElevationProfile(this.fire.incident.bearing);
        
        //var angle = fov * (this.fire.incident.width/)
        this.map.hideDetections();
        this.map.displayDetection(this.fire.incident.incidentId, this.fire.camera, this.fire.incident.bearing, this.fire.incident.width, distanceMeters);
        this.cameraLatitude = c.latitude != null ? Math.round(c.latitude * 100000) / 100000 : undefined;
        this.cameraLongitude = c.longitude != null ? Math.round(c.longitude * 100000) / 100000 : undefined;
        
        cameraTwins.push(this.fire.camera.twin);
        
        // Check if there are duplicate incidents
        if (this.fire.incident.duplicateIncidents && this.fire.incident.duplicateIncidents.length > 0) {
          console.log(`Loading ${this.fire.incident.duplicateIncidents.length} duplicate incident cameras`);
          
          let duplicatesLoaded = 0;
          const totalDuplicates = this.fire.incident.duplicateIncidents.length;
          
          for (let duplicateIncident of this.fire.incident.duplicateIncidents) {
            if (duplicateIncident.site && duplicateIncident.site.siteId) {
              this.fire.getCamera(duplicateIncident.site.siteId, true, duplicateCamera => {
                const normalizedDuplicateLatitude = duplicateCamera?.latitude ?? duplicateCamera?.twin?.latitude;
                const normalizedDuplicateLongitude = duplicateCamera?.longitude ?? duplicateCamera?.twin?.longitude;
                if (normalizedDuplicateLatitude != null) {
                  duplicateCamera.latitude = normalizedDuplicateLatitude;
                  if (duplicateCamera.twin) {
                    duplicateCamera.twin.latitude = normalizedDuplicateLatitude;
                  }
                }
                if (normalizedDuplicateLongitude != null) {
                  duplicateCamera.longitude = normalizedDuplicateLongitude;
                  if (duplicateCamera.twin) {
                    duplicateCamera.twin.longitude = normalizedDuplicateLongitude;
                  }
                }

                // Display the duplicate camera site
                this.map.displaySites([duplicateCamera.twin], this.getIcon, null, null, false);
                
                // Convert distance from km to meters for the arc radius, increased by 10%
                let duplicateDistanceKm: number | undefined;
                if (duplicateIncident.initialDistance) {
                  duplicateDistanceKm = duplicateIncident.initialDistance;
                } else if (this.location?.latitude != null && this.location?.longitude != null && duplicateCamera.latitude != null && duplicateCamera.longitude != null) {
                  // Calculate distance if not provided
                  duplicateDistanceKm = this.calculateDistance(duplicateCamera.latitude, duplicateCamera.longitude, this.location.latitude, this.location.longitude);
                }
                const duplicateDistanceMeters = duplicateDistanceKm ? duplicateDistanceKm * 1100 : undefined;
                
                // Display bearing from duplicate camera to the incident
                this.map.displayBearing(duplicateCamera.twin, duplicateIncident.cameraBearing, duplicateIncident.cameraFieldOfView, duplicateDistanceMeters);
                
                // Display detection arc
                this.map.displayDetection(duplicateIncident.incidentId, duplicateCamera, duplicateIncident.bearing, duplicateIncident.width, duplicateDistanceMeters);
                
                cameraTwins.push(duplicateCamera.twin);
                duplicatesLoaded++;
                
                // After all duplicates are loaded, fit bounds
                if (duplicatesLoaded === totalDuplicates) {
                  this.fitMapBoundsToAllCameras(cameraTwins);
                }
              });
            }
          }
        } else if (this.location?.latitude != null && this.location?.longitude != null) {
          // No duplicates, but we have an incident location - fit bounds to show camera and incident
          this.fitMapBoundsToCameraAndIncident(this.fire.camera.twin, this.location);
        }
      });
      console.log("Incident", this.fire.incident);
      //if (this.fire.incident.initialLocationLat && this.fire.incident.initialLocationLon){
      this.location = {
        identifier: this.fire.incident.incidentId,
        latitude: this.fire.incident.initialLocationLat,
        longitude: this.fire.incident.initialLocationLon
      };
      this.map.showActiveIncidentLocation(this.location, this.iconSvc.pins['Fire Detection']);
      this.selectedImageIndex = this.fire.incident.detections.length - 1;
      //}
      
      // Load area of interest if present
      this.loadAreaOfInterest();
      // show all the other locations of fires
      if (this.fire.incidents == null){
        await this.fire.getIncidents();
      }
      if (this.fire.incidents) {
        for (let incident of this.fire.incidents) {
          if (incident.incidentId != this.fire.incident.incidentId) {
            const location = {
              identifier: incident.incidentId,
              latitude: incident.initialLocationLat,
              longitude: incident.initialLocationLon
            };
            const popupContent = this.createIncidentPopupContent(incident);
            this.map.showIncidentLocation(location, this.iconSvc.pins['Fire Other'], null, popupContent);
          }
        }
      }
      // we need to do this show other locations differently as it currently overwrites the original
      const siteUri = this.fire.incident.site.siteUri;
      const imageUri = this.fire.incident.imageFeedUri;
      if (imageUri != null) {
        // quickly load the latest image
        this.dataService.DataGetData({
          customerId: this.app.customerId,
          request: {
            period: 'latest',
            type: 'media',
            timeZoneOffset: this.app.getTimeZoneOffset(null),
            forceEmbed: false,
            index: 0,
            publishedIdentifier: null,
            siteUri: null,
            timeSeries: {
              single: {
                variable: {
                  uri: imageUri,
                  transforms: null,
                }
              }
            }
          }
        })
          .subscribe(r => {
            this.latestImages = r.values.map(i => { return { src: i.valueStr, overlay: null, timeStamp: i.timeStamp } as SmartImageDetail });
          });
      }
      //this.liveWidget = { name: "Live", showTitle: false, realTime: false, period: '-1h:1h', refreshInterval: 0, timeSeriesList: [{ uri: 'in-restapi-restapi-southsisters-288', forceEmbed: false, sourceType: 'media' } as TimeSeriesDetail] } as IMultiSourceMultiValueWidget;
      this.detectionImages = this.fire.incident.detections.map(i => { return { src: i.imageUrl, overlay: i.detectionMetaData, timeStamp: i.firstDetected } as SmartImageDetail });
      this.latestZoomedImages = [{ src: this.fire.incident.firstZoomedImageUrl, timeStamp: this.fire.incident.fireIncidentDate } as SmartImageDetail];

      if (this.fire.incident.detections && this.fire.incident.detections.length > 0) {
        var timelines = this.fire.incident.detections.map(t => {
          return { time: t.firstDetected, type: t.detectionType?.displayName } as any;
        });
        const notes = this.fire.incident.notes.map(t => {
          return { time: t.lastModifiedDate, type: 'Note', text: t.notes, by: t.lastModifiedBy } as any;
        });
        timelines = timelines.concat(notes);
        // Oldest first, newest last.
        timelines.sort((a, b) => {
          const aTime = this.getTimestampMs(a.time);
          const bTime = this.getTimestampMs(b.time);
          return aTime - bTime;
        });
        this.timelines = timelines;
      }
    }
  }

  showZones: boolean = false;
  zones: Zone[];
  toggleIgnoreZones() {
    this.showZones = !this.showZones;
    if (this.zones == null) {
      this.svc.FireForesightGetIgnoreZones({ customerId: this.app.customerId, siteUri: this.fire.camera.siteUri }).subscribe(r => {
        this.zones = r;
      });
    }
  }

  public fireSpreadSelected: boolean = false;
  toggleFireSpread(){
    this.fireSpreadSelected = !this.fireSpreadSelected;
    if (this.fireSpreadSelected){
      // load the fire spread data
      this.svc.FireForesightGetLastestFireSpreadModel({ customerId: this.app.customerId, incidentId: this.fire.incident.incidentId }).subscribe(r => {
         if (r && r.outputsJson) {
            r.outputsJson = JSON.parse(r.outputsJson);
            console.log("Fire Spread Model", r);
            this.fireSpreadModel = r.outputsJson;
            this.currentFrameIndex = 0;
            if (this.fireSpreadModel && this.fireSpreadModel.frames && this.fireSpreadModel.frames.length > 0) {
              this.startFireSpreadAnimation();
            } else {
              this.toasterService.error("No fire spread frames available");
            }
        }
      }, err => {
        this.toasterService.error("Failed to load fire spread model");
        this.fireSpreadSelected = false;
      });
    } else {
      this.stopFireSpreadAnimation();
    }
  }

  startFireSpreadAnimation() {
    this.isAnimating = true;
    this.displayFireSpreadFrame(this.currentFrameIndex);
    
    this.animationInterval = setInterval(() => {
      if (this.isAnimating) {
        this.currentFrameIndex = (this.currentFrameIndex + 1) % this.fireSpreadModel.frames.length;
        this.displayFireSpreadFrame(this.currentFrameIndex);
      }
    }, 1000); // 1 second per frame
  }

  stopFireSpreadAnimation() {
    try{
      this.isAnimating = false;
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
      if (this.fireSpreadLayer) {
        this.map.removeLayer(this.fireSpreadLayer);
        this.fireSpreadLayer = null;
      }
    }
    catch{
      
    }
  }
  
  removeAreaOfInterest() {
    try{
      if (this.areaOfInterestLayer) {
        this.map.removeLayer(this.areaOfInterestLayer);
        this.areaOfInterestLayer = null;
      }
    }
    catch {
      
    }
  }
  
  loadAreaOfInterest() {
    // Check if area of interest is defined
    if (!this.fire.incident || !this.fire.incident.areaOfInterest) {
      return;
    }
    
    try {
      // Parse the GeoJSON string
      const geoJsonData = JSON.parse(this.fire.incident.areaOfInterest);
      
      // Define styling for area of interest polygons (blue/purple to distinguish from fire spread)
      const styles = JSON.stringify({
        color: '#4A90E2',
        fillColor: '#6BB6FF',
        fillOpacity: 0.3,
        weight: 2
      });
      
      // Load the GeoJSON layer onto the map
      this.areaOfInterestLayer = this.map.loadLinkLayerContent(
        'geojson',
        999998, // Use a high layer ID to avoid conflicts (999999 is used by fire spread)
        geoJsonData,
        'Area of Interest',
        styles,
        256,
        false,
        null
      );
      
      console.log('Area of Interest loaded successfully');
    } catch (error) {
      console.warn('Failed to parse or load area of interest GeoJSON:', error);
      // Don't block incident loading if area of interest fails
    }
  }

  displayFireSpreadFrame(index: number) {
    if (!this.fireSpreadModel || !this.fireSpreadModel.frames || index >= this.fireSpreadModel.frames.length) {
      return;
    }

    // Remove previous layer
    if (this.fireSpreadLayer) {
      this.map.removeLayer(this.fireSpreadLayer);
    }

    // Get the frame data
    const frame = this.fireSpreadModel.frames[index];
    const geoJson = frame.fire_footprint;

    // Define styling for fire spread polygons
    const styles = JSON.stringify({
      color: '#FF4500',
      fillColor: '#FF6347',
      fillOpacity: 0.5,
      weight: 2
    });

    // Load the GeoJSON layer
    this.fireSpreadLayer = this.map.loadLinkLayerContent(
      'geojson',
      999999, // Use a high layer ID to avoid conflicts
      geoJson,
      'Fire Spread Model',
      styles,
      256,
      false,
      null
    );
  }

  setFireSpreadFrame(index: number) {
    if (this.fireSpreadModel && index >= 0 && index < this.fireSpreadModel.frames.length) {
      this.currentFrameIndex = index;
      this.displayFireSpreadFrame(index);
      // Pause animation when manually selecting a frame
      if (this.isAnimating) {
        this.isAnimating = false;
        if (this.animationInterval) {
          clearInterval(this.animationInterval);
          this.animationInterval = null;
        }
      }
    }
  }

  stepFireSpreadForward() {
    if (this.fireSpreadModel && this.fireSpreadModel.frames) {
      const nextIndex = (this.currentFrameIndex + 1) % this.fireSpreadModel.frames.length;
      this.setFireSpreadFrame(nextIndex);
    }
  }

  stepFireSpreadBackward() {
    if (this.fireSpreadModel && this.fireSpreadModel.frames) {
      const prevIndex = (this.currentFrameIndex - 1 + this.fireSpreadModel.frames.length) % this.fireSpreadModel.frames.length;
      this.setFireSpreadFrame(prevIndex);
    }
  }

  toggleFireSpreadAnimation() {
    if (this.isAnimating) {
      this.isAnimating = false;
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    } else {
      this.startFireSpreadAnimation();
    }
  }

  getFireSpreadFrameTimestamp(): string {
    if (this.fireSpreadModel && this.fireSpreadModel.frames && this.fireSpreadModel.frames[this.currentFrameIndex]) {
      return this.fireSpreadModel.frames[this.currentFrameIndex].timestamp;
    }
    return '';
  }

  toogleZoomedImages() {
    this.zoomed = !this.zoomed;
    if (this.zoomed) {
      if (this.fire.incident.zoomedImageFeedUri != null) {
        // now load the larger data set of images
        // time = 'yyyy-MM-dd HH:mm:ss,2024-11-13 11:00:00'
        const start = this.formatDate(this.fire.incident.incidentStartDate);
        const end = this.fire.incident.incidentEndDate == null ? '1h' : this.formatDate(this.fire.incident.incidentEndDate);
        /*if (end == null || end == ''){
          end = '1h';
        }*/
        const period = `${start},${end}`;
        console.log(period);
        this.dataService.DataGetData({
          customerId: this.app.customerId,
          request: {
            period: period,
            type: 'media',
            timeZoneOffset: this.app.getTimeZoneOffset(null),
            forceEmbed: false,
            index: 0,
            publishedIdentifier: null,
            siteUri: null,
            timeSeries: {
              single: {
                variable: {
                  uri: this.fire.incident.zoomedImageFeedUri,
                  transforms: null,
                }
              }
            }
          }
        })
          .subscribe(r => {
            this.latestZoomedImages = r.values.map(i => { return { src: i.valueStr, overlay: null, timeStamp: i.timeStamp } as SmartImageDetail });
          });
      }
    }
  }

  displayDirection(event) {
    if (event && this.fire && this.fire.twin && this.fire.twin.parameters) {
      console.log(event);
      //var step =  360 / Math.max(Object.values(this.siteTwin.parameters).filter(f => !f.hidden).length,2);
      //var param = Object.values(this.siteTwin.parameters)[this.selectedImageIndex];
      //debugger;
      var fov = this.fire.incident.cameraFieldOfView;//  360 / Math.max(Object.values(this.fire.twin.parameters).filter(f => f.bearing != null && !f.hidden).length,2);
      var min = this.fire.incident.cameraBearing - (fov / 2);
      var max = this.fire.incident.cameraBearing + (fov / 2);
      var mov = event.x * fov / 100;
      var bearing = Math.round((min + mov) * 100) / 100;

      this.showLineAt = { percent: event.x, deg: bearing };

      this.map.displayArc(this.fire.camera.twin, bearing, 0.5);
    }
  }

  onImageClick(event) {
    if (event && this.fire && this.fire.twin && this.fire.twin.parameters) {
      console.log('Image clicked at position:', event);
      
      var fov = this.fire.incident.cameraFieldOfView;
      var min = this.fire.incident.cameraBearing - (fov / 2);
      var max = this.fire.incident.cameraBearing + (fov / 2);
      var mov = event.x * fov / 100;
      var bearing = Math.round((min + mov) * 100) / 100;

      console.log('Calculated bearing from click:', bearing);
      
      // Update the elevation profile for the clicked bearing
      this.getElevationProfile(bearing);
    }
  }

  escalate(responsiblePartyId: number) {
    this.fire.incident.responsiblePartyId = responsiblePartyId;
    const status = this.list.find(f => f.statusId == 8);
    this.updateStatus(status);
  }

  notAFire(falsePositiveTypeId: number) {
    this.fire.incident.falsePositiveTypeId = falsePositiveTypeId;
    const status = this.list.find(f => f.statusId == 5);
    this.updateStatus(status);
  }

  updateStatus(status: StatusType) {
    this.fire.incident.status = status;
    if (status.statusId == 8 && this.fire.incident.responsiblePartyId == null) {
      // request user to fill in who is responsible
      this.responsibleModal.show();
    }
    else if (status.statusId == 5 && this.fire.incident.falsePositiveTypeId == null) {
      // its not a fire - can the user categorise it
      this.falsePositiveModal.show();
    }
    else {
      this.fire.update(this.fire.incident, () => {
        this.toasterService.success("Updated", "Incident");
        // only move to the next incident if you say "Not a Fire"
        if (this.fire.incident.status.statusId == 5) {
          this.fire.next(() => this.loadIncident());
        }
      });
    }
  }

  onCommentKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.addNewNote();
    }
  }

  updateIncident() {
    this.fire.update(this.fire.incident, s => {
      this.toasterService.success("Incident Saved");
    });
  }

  //proposed BH changes
  //updateStatus(status: StatusType) {
  //  this.fire.incident.status = status;
  //  this.fire.getUpdate(this.fire.incident).subscribe(i => {
  //    this.fire.setUpdate(i);
  //    this.fire.incident = i;
  //    this.toasterService.success("Updated", "Incident");
  //    if (this.fire.incident.status.statusId == 5) {
  //      this.fire.next(() => this.loadIncident());
  //    }
  //  });
  //}

  getIcon(site: SiteTwin, pins: any[]) {
    const icon = { icon: pins[site.siteType] ?? pins["blueSelected"] };
    return icon;
  }

  addNewNote() {
    this.svc.FireForesightAddNote({ incidentId: this.incidentId, notes: this.newNote }).subscribe(n => {
      this.fire.incident.notes.push(n);
      this.newNote = "";
    })
  }

  createIncidentPopupContent(otherIncident: Incident): string {
    const detectionDate = new Date(otherIncident.fireIncidentDate).toLocaleString();
    const status = otherIncident.status?.displayName || 'Unknown';
    const confidence = otherIncident.confidence || 0;
    const siteName = otherIncident.site?.name || 'Unknown Location';
    
    // Determine what action buttons to show
    let actionButtons = '';
    if (otherIncident.originalIncidentId) {
      // This incident is a duplicate of another, show link to original
      actionButtons = `
        <a href="/#/fire-foresight/incident/${otherIncident.originalIncidentId}" 
           class="btn btn-sm btn-info mt-2 w-100" 
           target="_blank">
          <i class="fa fa-link"></i> View Original Incident #${otherIncident.originalIncidentId}
        </a>`;
    } else {
      // Show merge button
      actionButtons = `
        <button 
          class="btn btn-sm btn-primary mt-2 w-100" 
          onclick="window.mergeIncident(${this.fire.incident.incidentId}, ${otherIncident.incidentId})">
          <i class="fa fa-code-fork"></i> Merge with Current Incident
        </button>`;
    }
    
    return `
      <div class="incident-popup-content">
        <h4>Incident #${otherIncident.incidentId}</h4>
        ${otherIncident.incidentTitle ? `<p><strong>${otherIncident.incidentTitle}</strong></p>` : ''}
        <table class="table table-sm">
          <tr><td><strong>Site:</strong></td><td>${siteName}</td></tr>
          <tr><td><strong>Status:</strong></td><td>${status}</td></tr>
          <tr><td><strong>Confidence:</strong></td><td>${confidence}%</td></tr>
          <tr><td><strong>Detected:</strong></td><td>${detectionDate}</td></tr>
          ${otherIncident.initialLocationLat && otherIncident.initialLocationLon ? 
            `<tr><td><strong>Location:</strong></td><td>${otherIncident.initialLocationLat.toFixed(3)}°, ${otherIncident.initialLocationLon.toFixed(3)}°</td></tr>` : ''}
          ${otherIncident.originalIncidentId ? 
            `<tr><td><strong>Original:</strong></td><td>Incident #${otherIncident.originalIncidentId}</td></tr>` : ''}
        </table>
        ${actionButtons}
      </div>
    `;
  }

  mergeIncidents(secondaryIncidentId: number, primaryIncidentId: number) {
    // TODO: Implement the actual merge logic
    // This should call the appropriate API endpoint to merge the two incidents
    // For now, show a notification to indicate the action was triggered
    
    console.log(`Merge incident ${secondaryIncidentId} into incident ${primaryIncidentId}`);

    this.svc.FireForesightMergeIncidents({ primaryIncidentId, secondaryIncidentId }).subscribe({
      next: () => {
        this.toasterService.success(`Successfully merged incident #${secondaryIncidentId} into #${primaryIncidentId}`, 'Merge Successful', { timeOut: 5000 });
        // After merging, you would typically want to refresh the incident data to reflect the changes
        this.fire.getIncident(this.incidentId, i => {
          this.loadIncident();
        });
      },
      error: (err) => {
        console.error('Merge failed', err);
        this.toasterService.error(`Failed to merge incident #${secondaryIncidentId} into #${primaryIncidentId}`, 'Merge Failed', { timeOut: 5000 });
      }
    });
  }

  fitMapBoundsToAllCameras(cameraTwins: SiteTwin[]) {
    if (!this.map || !cameraTwins || cameraTwins.length === 0) return;
    
    // Create an array of lat/lng pairs for all cameras
    const bounds: L.LatLngExpression[] = [];
    
    for (let camera of cameraTwins) {
      const latitude = camera.latitude;
      const longitude = camera.longitude;
      if (latitude != null && longitude != null) {
        bounds.push([latitude, longitude]);
      }
    }
    
    // Add incident location if it exists
    const incidentLatitude = this.location?.latitude;
    const incidentLongitude = this.location?.longitude;
    if (incidentLatitude != null && incidentLongitude != null) {
      bounds.push([incidentLatitude, incidentLongitude]);
    }
    
    if (bounds.length > 0) {
      try {
        const latLngBounds = L.latLngBounds(bounds);
        this.map.map.fitBounds(latLngBounds, {
          padding: [50, 50],
          maxZoom: 13
        });
      } catch (ex) {
        console.error('Error fitting bounds to cameras', ex);
      }
    }
  }

  fitMapBoundsToCameraAndIncident(cameraTwin: SiteTwin, incidentLocation: Location) {
    try{
      if (!this.map || !cameraTwin || !incidentLocation) return;
      
      const bounds: L.LatLngExpression[] = [];
      
      const cameraLatitude = cameraTwin.latitude;
      const cameraLongitude = cameraTwin.longitude;
      if (cameraLatitude != null && cameraLongitude != null) {
        bounds.push([cameraLatitude, cameraLongitude]);
      }
      
      const incidentLatitude = incidentLocation.latitude;
      const incidentLongitude = incidentLocation.longitude;
      if (incidentLatitude != null && incidentLongitude != null) {
        bounds.push([incidentLatitude, incidentLongitude]);
      }
      
      if (bounds.length > 1) {
        try {
          const latLngBounds = L.latLngBounds(bounds);
          this.map.map.fitBounds(latLngBounds, {
            padding: [50, 50],
            maxZoom: 13
          });
        } catch (ex) {
          console.error('Error fitting bounds to camera and incident', ex);
        }
      }
    }
    catch (E){
        console.error('Error in fitMapBoundsToCameraAndIncident', E);
    }
  }

  resizeMap() {
    const map = this.map.map;
    if (this.mapExpand) {
      // Account for elevation profile chart height (250px chart + 30px padding) when visible
      const elevationChartHeight = this.elevationProfile ? 230 : 0;
      this.mapHeight = window.innerHeight - 80 - elevationChartHeight;
    }
    else {
      this.mapHeight = 370;
    }
    setTimeout(function () { map.invalidateSize() }, 50);
  }

  /*private normalizeLatitude(latitude: number): number {
    if (latitude == null || isNaN(latitude as any)) {
      return null;
    }

    if (latitude < -90 || latitude > 90) {
      return null;
    }

    return latitude;
  }

  private normalizeLongitude(longitude: number): number {
    if (longitude == null || isNaN(longitude as any)) {
      return null;
    }

    return ((((longitude + 180) % 360) + 360) % 360) - 180;
  }*/

  private displayAdditionalLoadedFireCameras(excludedSiteIds: Set<number>): void {
    if (!this.map || !this.fire?.cameras || this.fire.cameras.length === 0) {
      return;
    }

    const additionalTwins: SiteTwin[] = [];
    console.log("Loading additional cameras");
    for (const camera of this.fire.cameras) {
      if (!camera || excludedSiteIds.has(camera.siteId) || !camera.twin) {
        continue;
      }

      const latitude = camera.latitude ?? camera.twin.latitude;
      const longitude = camera.longitude ?? camera.twin.longitude;
      if (latitude == null || longitude == null) {
        continue;
      }

      const twin: SiteTwin = {
        ...camera.twin,
        latitude,
        longitude,
        siteName: camera.twin.siteName || camera.name,
        siteDescription: camera.twin.siteDescription || camera.name,
        siteType: camera.twin.siteType || 'Fire Camera'
      };

      additionalTwins.push(twin);
    }

    if (additionalTwins.length > 0) {
      this.map.displaySites(additionalTwins, this.getIcon, null, null, false);
    }
  }

  deepClone(obj) { if (obj === null || typeof obj !== 'object') { return obj; } if (obj instanceof Date) { return new Date(obj); } if (obj instanceof Array) { const arrCopy = []; for (let i = 0; i < obj.length; i++) { arrCopy[i] = this.deepClone(obj[i]); } return arrCopy; } if (obj instanceof Object) { const objCopy = {}; for (const key in obj) { if (obj.hasOwnProperty(key)) { objCopy[key] = this.deepClone(obj[key]); } } return objCopy; } throw new Error('Unable to copy object! Its type isn\'t supported.'); }

}
